export enum LoaderType {
  Template = 'Template',
  Prompt = 'Prompt',
}
export interface ISkeletonLoader {
  className?: string
  type?: LoaderType
  color?: string
}
